import type { ReactNode } from 'react';
import { useGiveNowSessionStorage } from '../../hooks';
import { GiveNowContext } from '../GiveNowContext';

type GiveNowProviderProperties = {
  children: ReactNode;
};

export const GiveNowProvider = ({ children }: GiveNowProviderProperties) => {
  const value = useGiveNowSessionStorage();

  return <GiveNowContext.Provider value={value}>{children}</GiveNowContext.Provider>;
};
